define('v3/Common/Services/jwtTokenService',[
	'jwt_decode',
	'lodash',
	'env',
	'v3/Common/Services/Backend/jwtTokenBackend'
],
function (jwtDecode, _, env, jwtBackend) {
	return {
		getTokenForCurrentClassId: function (token, impersonateToken) {
			var decodedToken = getDecodedToken(token);

			if (decodedToken) {
				var isChangeSchoolRoleAvailable = isChangeSchoolRole(decodedToken);
				if (isChangeSchoolRoleAvailable) {
					var currentClassId = env.userInfo.classId;
					var defaultClassId = decodedToken.class_id;

					if (currentClassId === defaultClassId) {
						return token;
					} else {
						var impersonateTokenDecoded = getDecodedToken(impersonateToken);

						if (impersonateTokenDecoded) {
							var impersonateClassId = impersonateTokenDecoded.class_id;

							if (currentClassId === impersonateClassId) {
								return impersonateToken;
							}
						}
					}

					return null;
				}
			}

			return token;
		},
		isImpersonating: function (token) {
			var decodedToken = getDecodedToken(token);

			if (isChangeSchoolRole(decodedToken || { role: [] })) {
				var currentClassId = env.userInfo.classId;
				var defaultClassId = decodedToken.class_id;

				return currentClassId !== defaultClassId;
			}

			return false;
		},
		isImpersonatingTokenValid: function (token) {
			var decodedToken = getDecodedToken(token);

			if (isDecodedTokenExpired(decodedToken)) {
				return false;
			}

			var currentSchoolId = env.userInfo.schoolId;
			var impersonatingSchoolId = decodedToken.school_id;

			return currentSchoolId === impersonatingSchoolId;
		},
		getImpersonateToken: function (authToken) {
			return jwtBackend.getImpersonateToken(authToken);
		},
		isTokenExpired: function (token) {
			var decodedToken = getDecodedToken(token);

			return isDecodedTokenExpired(decodedToken);
		},
		renewImpersonateToken: function (accessToken) {
			return jwtBackend.getImpersonateToken(accessToken);
		}
	};

	function getDecodedToken (token) {
		try {
			if (token) {
				var decodedToken = jwtDecode(token);
				if (decodedToken) {
					return decodedToken;
				}
			}
		} catch (e) {}
		return null;
	}

	function isChangeSchoolRole (decodedToken) {
		var isChangeSchoolRoleAvailable = (decodedToken.role.indexOf('change_school') > -1);
		return isChangeSchoolRoleAvailable;
	}

	function isDecodedTokenExpired (decodedToken) {
		if (decodedToken) {
			return ((decodedToken.exp || 0) < (Date.now() - env.clientTimeOffset) / 1000);
		}
		return true;
	}
});

